/* eslint-disable */
import React, { Fragment, useState, useEffect, useReducer } from 'react'
import { Card, CardBody, CardTitle, Input, InputGroup, InputGroupText, Label, Button, Offcanvas, OffcanvasHeader, OffcanvasBody, Col, Row, Form, FormFeedback } from 'reactstrap'
import { ColumnChooser, ColumnDirective, ColumnsDirective, CommandColumn, Edit, Filter, GridComponent, Group, Inject, Page, Sort, Toolbar, Selection } from '@syncfusion/ej2-react-grids'
import Flatpickr from 'react-flatpickr'
import ProdottiTabella from '../ProddottiTabella'
import { configSetProdottoCaratteristiche } from '../../../../@core/auth/apiService/configs'
import axios from 'axios'
import toast from 'react-hot-toast'
import moment from 'moment'
import { Controller, useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const reducer = (state, { type, payload }) => {
    switch (type) {
        case 'INIZIO':
            return {
                ...state,
                lunghezza: payload.lunghezza,
                larghezza: payload.larghezza,
                profondita: payload.profondita,
                pesoNetto: payload.pesoNetto,
                pesoLordo: payload.pesoLordo,
                dataInizioServizio: payload.dataInizioServizio,
                dataFineServizio: payload.dataFineServizio,
                dataInizioSupporto: payload.dataInizioSupporto,
                dataFineSupporto: payload.dataFineSupporto,
                dataInizioPrenotazione: payload.dataInizioPrenotazione,
                dataFinePrenotazione: payload.dataFinePrenotazione,
                associati: []
            }
        case 'INIZIO_SERVIZIO':
            return { ...state, dataInizioServizio: moment(payload[0]).format('YYYY-MM-DD') }
        case 'INIZIO_SUPPORTO':
            return { ...state, dataInizioSupporto: moment(payload[0]).format('YYYY-MM-DD') }
        case 'INIZIO_PRENOTAZIONE':
            return { ...state, dataInizioPrenotazione: moment(payload[0]).format('YYYY-MM-DD') }
        case 'FINE_SERVIZIO':
            return { ...state, dataFineServizio: moment(payload[0]).format('YYYY-MM-DD') }
        case 'FINE_SUPPORTO':
            return { ...state, dataFineSupporto: moment(payload[0]).format('YYYY-MM-DD') }
        case 'FINE_PRENOTAZIONE':
            return { ...state, dataFinePrenotazione: moment(payload[0]).format('YYYY-MM-DD') }
        case 'LARGHEZZA':
            return { ...state, larghezza: payload }
        case 'LUNGHEZZA':
            return { ...state, lunghezza: payload }
        case 'PROFONDITA':
            return { ...state, profondita: payload }
        case 'NETTO':
            return { ...state, pesoNetto: payload }
        case 'LORDO':
            return { ...state, pesoLordo: payload }
        default:
            return { ...state }
    }
}
const DetailsCharacteristic = (props) => {
    const { value } = props
    const { id } = props

    const initialState =
    {
        id: Number(id),
        lunghezza: ' ',
        larghezza: ' ',
        profondita: ' ',
        pesoNetto: ' ',
        pesoLordo: ' ',
        dataInizioServizio: null,
        dataFineServizio: null,
        dataInizioSupporto: null,
        dataFineSupporto: null,
        dataInizioPrenotazione: null,
        dataFinePrenotazione: null,
        associati: []
    }
    const { prodottoCaratteristiche } = props
    const [canvasPlacement, setCanvasPlacement] = useState('start')
    const [canvasOpen, setCanvasOpen] = useState(false)
    const [prodottiAssociati, setProdottiAssociati] = useState()
    const [state, dispatch] = useReducer(reducer, initialState)


    useEffect(() => {
        dispatch({ type: 'INIZIO', payload: prodottoCaratteristiche })
        setProdottiAssociati(prodottoCaratteristiche.prodottoAssociati)

    }, [])
    useEffect(() => { reset(state) }, [state])
    const onError = () => {
        toast.error('Modifica non eseguita, controlla i campi richiesti', {
            position: "top-right",
            duration: 3000,
            style: {
                background: 'red',
                color: 'white'
            }
        })
    }

    const onSubmit = () => {
        preparaDati('Semplice')
    }

    const defaultSchema = yup.object().shape({
        lunghezza: yup.number().required(),
        larghezza: yup.number().required(),
        profondita: yup.number().required(),
        pesoNetto: yup.number().required(),
        pesoLordo: yup.number().required()
    })
    //useForm per la validazione
    const {
        control,
        reset,
        handleSubmit,
        formState: { errors }
    } = useForm({ mode: 'onChange', resolver: yupResolver(defaultSchema), defaultValues: state })



    // PARTE DI CODICE LEGATA ALLA GRIGLIA DEI PRODOTTI UNIFICATI.
    let grid
    const constructor = {
        editOptions: { allowEditing: true, allowDeleting: true },
        commands:
            [
                {
                    type: 'Elimina',
                    id: 'EliminaSingolo',
                    target: '.e-column',
                    buttonOption: {
                        iconCss: 'e-icons e-trash',
                        cssClass: 'e-flat'
                    }
                }
            ]
    }
    const toolbarCustomItem = [
        { text: 'Elimina', tooltipText: 'Elimina', prefixIcon: 'e-delete', id: 'Elimina' },
        { text: 'Aggiungi', tooltipText: 'Aggiungi', prefixIcon: 'e-plus', id: 'aggiungiProdotto' },
        { text: 'Print' },
        'ColumnChooser',
        { text: 'Search' }
    ]
    const pullData = (data) => {
        setProdottiAssociati(data)
        toggleCanvasEnd()
        if (grid) {
            grid.refresh()
        }
    }
    const customButton = (args) => {
        if (args.commandColumn.id === 'EliminaSingolo') eliminaSingolo(args.rowData.id)
        else if (args.commandColumn.id === 'Modifica') modifica()
    }
    const eliminaSingolo = (id) => {
        prodottiAssociati.map((e, i) => {
            if (e.id === id) {
                prodottiAssociati.splice(i, 1)
            }
        })
        if (grid) {
            grid.refresh()
        }
    }
    const deleteRecords = () => {
        let recordSelezionati = grid.getSelectedRecords()
        recordSelezionati.forEach(el => { grid.deleteRecord('id', el) })
    }
    const toggleCanvasEnd = () => {
        setCanvasPlacement('end')
        setCanvasOpen(!canvasOpen)
    }

    // BUTTONS AZIONI DELLA TOOLBAR 
    const clickHandler = (args) => {
        if (args.item.id === 'Elimina') deleteRecords()
        if (args.item.id === 'aggiungiProdotto') toggleCanvasEnd()
    }

    //CHAMATA PER INVIARE LA MODIFICA DEI DATI ELABORATI 
    const invioModifica = async (data) => {
        const myResponse = await axios(configSetProdottoCaratteristiche(JSON.stringify([data])))
        if (myResponse.data.esito === 'OK') {
            toast.success('Associazione effettuata correttamente', {
                position: "top-right",
                duration: 3000,
                style: {
                    background: 'green',
                    color: 'white'
                }
            })
        } else {
            {
                toast.error('Si è verificato un errore durante la richiesta al server', {
                    position: "top-right",
                    duration: 3000,
                    style: {
                        background: 'red',
                        color: 'white'
                    }
                })
            }

        }
    }

    // FUNZIONE CHE PREPARA I DATI DA PASSARE COME BODY ALLA CHIAMATA (GESTISCE I DATI TRAMITE SWITCH ANALIZANDO I 3 CASI DI 'TIPO PRODOTTO')
    const preparaDati = (args) => {
        switch (args) {
            case 'Unificato':
                state.associati = prodottiAssociati.map(item => ({ id: item.id, codice: item.codice, nome: item.nome, prezzo: item.prezzo || null, costo: item.costo || null }))
                invioModifica(state)
                return state
            case 'Semplice':
                invioModifica(state)
                return state
            case 'Servizio':
                invioModifica(state)
                return state
            default:
                break;
        }
    }

    if (value === "Prodotto Semplice") return (
        <Card>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit, onError)}>
                    <CardTitle>
                        Dimensioni Fisiche
                    </CardTitle>
                    <Label>Larghezza</Label>
                    <InputGroup className='mb-2'>
                        <Controller
                            id='larghezza'
                            name='larghezza'
                            defaultValue={state.larghezza}
                            control={control}
                            render={({ field: { value, onChange, ...field } }) => <Input {...field} placeholder='Inserisci i dati' onChange={({ target: { value } }) => {
                                onChange(value)
                                dispatch({ type: 'LARGHEZZA', payload: value })
                            }}
                                value={state.larghezza || ''}
                                invalid={errors.larghezza && true}
                            />}
                        />
                        <InputGroupText>cm</InputGroupText>
                        {errors.larghezza && <FormFeedback>{'Larghezza non può essere vuoto'}</FormFeedback>}
                    </InputGroup>
                    <Label>Lunghezza</Label>
                    <InputGroup className='mb-2'>
                        <Controller
                            id='lunghezza'
                            name='lunghezza'
                            defaultValue={state.lunghezza}
                            control={control}
                            render={({ field: { value, onChange, ...field } }) => <Input {...field} placeholder='Inserisci i dati' onChange={({ target: { value } }) => {
                                onChange(value)
                                dispatch({ type: 'LUNGHEZZA', payload: value })
                            }}
                                value={state.lunghezza || ''}
                                invalid={errors.lunghezza && true}
                            />}
                        />
                        <InputGroupText>cm</InputGroupText>
                        {errors.lunghezza && <FormFeedback>{'Lunghezza non può essere vuoto'}</FormFeedback>}
                    </InputGroup>
                    <Label>Profondità</Label>
                    <InputGroup className='mb-2'>
                        <Controller
                            id='profondita'
                            name='profondita'
                            defaultValue={state.profondita}
                            control={control}
                            render={({ field: { value, onChange, ...field } }) => <Input {...field} placeholder='Inserisci i dati' onChange={({ target: { value } }) => {
                                onChange(value)
                                dispatch({ type: 'PROFONDITA', payload: value })
                            }}
                                value={state.profondita || ''}
                                invalid={errors.profondita && true}
                            />}
                        />
                        <InputGroupText>cm</InputGroupText>
                        {errors.profondita && <FormFeedback>{'Profondità non può essere vuoto'}</FormFeedback>}
                    </InputGroup>
                    <CardTitle> Peso </CardTitle>
                    <Label>Netto</Label>
                    <InputGroup className='mb-2'>
                        <Controller
                            id='pesoNetto'
                            name='pesoNetto'
                            defaultValue={state.pesoNetto}
                            control={control}
                            render={({ field: { value, onChange, ...field } }) => <Input {...field} placeholder='Inserisci i dati' onChange={({ target: { value } }) => {
                                onChange(value)
                                dispatch({ type: 'NETTO', payload: value })
                            }}
                                value={state.pesoNetto || ''}
                                invalid={errors.pesoNetto && true}
                            />}
                        />
                        <InputGroupText>Kg</InputGroupText>
                        {errors.pesoNetto && <FormFeedback>{'Peso netto non può essere vuoto'}</FormFeedback>}
                    </InputGroup>
                    <Label>Lordo</Label>
                    <InputGroup className='mb-2'>
                        <Controller
                            id='pesoLordo'
                            name='pesoLordo'
                            defaultValue={state.pesoLordo}
                            control={control}
                            render={({ field: { value, onChange, ...field } }) => <Input {...field} placeholder='Inserisci i dati' onChange={({ target: { value } }) => {
                                onChange(value)
                                dispatch({ type: 'LORDO', payload: value })
                            }}
                                value={state.pesoLordo || ''}
                                invalid={errors.pesoLordo && true}
                            />}
                        />
                        <InputGroupText>Kg</InputGroupText>
                        {errors.pesoNetto && <FormFeedback>{'Peso lordo non può essere vuoto'}</FormFeedback>}
                    </InputGroup>
                    <Button type='Submit' color='primary'>Salva</Button>
                </Form>
            </CardBody>
        </Card>
    )
    else if (value === 'Servizio') return (
        <Card>
            <CardBody>
                <Row>
                    <Col xl='6' md='6' sm='12'>
                        <Fragment>
                            <Label className='form-label' for='inizioServizio'>
                                Data Inizio Servizio
                            </Label>
                            <Flatpickr
                                className='form-control'
                                placeholder='Inserisci Data'
                                value={state.dataInizioServizio}
                                onChange={date => dispatch({ type: 'INIZIO_SERVIZIO', payload: date })}
                                options={{
                                    dateFormat: "Y-m-d",
                                }}
                                id='inizioServizio'
                            />
                        </Fragment>
                        <Fragment>
                            <Label className='form-label' for='inizioSupporto'>
                                Data Inizio Supporto
                            </Label>
                            <Flatpickr className='form-control' options={{ dateFormat: "Y-m-d" }} placeholder='Inserisci Data' value={state.dataInizioSupporto} onChange={date => dispatch({ type: 'INIZIO_SUPPORTO', payload: date })} id='inizioSupporto' />
                        </Fragment>
                        <Fragment>
                            <Label className='form-label' for='inizioPrenotaione'>
                                Data Inizio Prenotazione
                            </Label>
                            <Flatpickr className='form-control' options={{ dateFormat: "Y-m-d" }} placeholder='Inserisci Data' value={state.dataInizioPrenotazione} onChange={date => dispatch({ type: 'INIZIO_PRENOTAZIONE', payload: date })} id='inizioPrenotaione' />
                        </Fragment>
                    </Col>
                    <Col xl='6' md='6' sm='12'>
                        <Fragment>
                            <Label className='form-label' for='fineServizio'>
                                Data Fine Servizio
                            </Label>
                            <Flatpickr className='form-control' options={{ dateFormat: "Y-m-d" }} placeholder='Inserisci Data' value={state.dataFineServizio} onChange={date => dispatch({ type: 'FINE_SERVIZIO', payload: date })} id='fineServizio' />
                        </Fragment>
                        <Fragment>
                            <Label className='form-label' for='fineSupporto'>
                                Data Fine Supporto
                            </Label>
                            <Flatpickr className='form-control' options={{ dateFormat: "Y-m-d" }} placeholder='Inserisci Data' value={state.dataFineSupporto} onChange={date => dispatch({ type: 'FINE_SUPPORTO', payload: date })} id='fineSupporto' />
                        </Fragment>
                        <Fragment>
                            <Label className='form-label' for='finePrenotazione'>
                                Data Fine Prenotazione
                            </Label>
                            <Flatpickr className='form-control' options={{ dateFormat: "Y-m-d" }} placeholder='Inserisci Data' value={state.dataFinePrenotazione} onChange={date => dispatch({ type: 'FINE_PRENOTAZIONE', payload: date })} id='finePrenotazione' />
                        </Fragment>
                    </Col>
                </Row>
                <Button id='bottoneServizio' onClick={() => preparaDati('Servizio')} color='primary'>Salva</Button>
            </CardBody>
        </Card>
    )
    else if (value === 'Unificato') return (
        <Card>
            <CardBody>
                <GridComponent
                    rowHeight={26}
                    allowPaging={false}
                    dataSource={prodottiAssociati}
                    selectionSettings={{ checkboxMode: 'ResetOnRowClick', enableToggle: true, checkboxOnly: true }} allowSelection={true} allowFiltering={true} showColumnChooser={true} toolbar={toolbarCustomItem} filterSettings={{ type: "Menu" }}
                    allowSorting={true}
                    editSettings=
                    {{
                        allowEditing: false,
                        allowDeleting: true
                    }}
                    ref={g => (grid = g)}
                    toolbarClick={clickHandler}
                    commandClick={customButton}
                >
                    <>
                        <Offcanvas style={{ width: '1200px' }} direction={canvasPlacement} isOpen={canvasOpen} toggle={toggleCanvasEnd}>
                            <OffcanvasHeader toggle={toggleCanvasEnd}>Aggiungi prodotto </OffcanvasHeader>
                            <OffcanvasBody
                                className='my-auto mx-0 flex-grow-0'>
                                <ProdottiTabella value={prodottiAssociati} pullData={(data) => pullData(data)}></ProdottiTabella>
                            </OffcanvasBody>
                        </Offcanvas>
                    </>

                    <ColumnsDirective>
                        <ColumnDirective type='checkbox' width='30' />
                        <ColumnDirective field='azioni' width='70' textAlign="left" showInColumnChooser={false} allowFiltering={false} commands={constructor.commands} displayHtmlEncode={false} />
                        <ColumnDirective field='id' width='30' visible={false} isPrimaryKey={true} />
                        <ColumnDirective field='codice' width='100' clipMode='EllipsisWithTooltip' />
                        <ColumnDirective field='nome' width='200' textAlign="center" clipMode='EllipsisWithTooltip' />
                        <ColumnDirective field='QNT' width='100' format="" textAlign="center" />
                        <ColumnDirective field='prezzoVendita' width='100' headerText='prezzo' />
                        <ColumnDirective field='costo' width='100' />
                    </ColumnsDirective>
                    <Inject services={[Page, Sort, Filter, Group, CommandColumn, Edit, Toolbar, ColumnChooser, Selection]} />
                </GridComponent>
                <Button id='bottoneUnificato' onClick={() => preparaDati('Unificato')} color='primary'>Salva</Button>
            </CardBody>
        </Card>
    )
}

export default DetailsCharacteristic